import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NickyButtonComponent } from 'src/app/components/form/nicky-button/nicky-button.component';

@Component({
  selector: 'app-modal-footer',
  imports: [CommonModule, TranslateModule, NickyButtonComponent],
  templateUrl: './modal-footer.component.html',
})
export class ModalFooterComponent {
  @Input() primaryButtonText: string = 'done';
  @Input() secondaryButtonText: string = 'cancel';
  @Input() showPrimaryButton: boolean = true;
  @Input() showSecondaryButton: boolean = true;
  @Input() primaryButtonVariant: 'primary' | 'danger' = 'primary';
  @Input() primaryButtonId: string = '';
  @Input() secondaryButtonId: string = '';
  @Input() primaryButtonDisabled: boolean = false;

  @Output() primaryClick = new EventEmitter<void>();
  @Output() secondaryClick = new EventEmitter<void>();

  onPrimaryClick(): void {
    this.primaryClick.emit();
  }

  onSecondaryClick(): void {
    this.secondaryClick.emit();
  }
}
